'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import RoundedButton from 'layout-dnd-components/DndToolbar/RoundedButton';
import RectangularButton from 'layout-dnd-components/DndToolbar/RectangularButton';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { openPatagoniaInpageSectionsPanel, openSectionsLibraryModal } from 'ContentEditorUI/redux/actions/inpageActions';
import { getHasSectionsLibraryAccess } from 'ContentEditorUI/redux/selectors/sectionsSelectors';
import { OFFSCREEN_POSITION } from 'InpageEditorUI/lib/layoutSection/constants';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { SECTIONS_LIBRARY_TOUR } from 'ContentEditorUI/constants/tours';
import I18n from 'I18n';
import { logLayoutSectionEvent } from 'InpageEditorUI/eventsAsActions/layoutTransitionEventsAsActions';
import { LAYOUT_SECTION_TRACKING } from 'ContentEditorUI/lib/layoutSection/constants';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { AFTER, BEFORE } from 'layout-dnd-utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const mapDispatchToProps = {
  openPatagoniaInpageSectionsPanel,
  openSectionsLibraryModal
};
const mapStateToProps = state => {
  return {
    hasSectionsLibraryAccess: getHasSectionsLibraryAccess(state)
  };
};

/**
 * @param {number} props.top (optional)
 * @param {string} props.layoutSectionId (optional)
 * @param {number} props.left (optional)
 * @param {number} props.highlightTop (optional)
 * @param {number} props.highlightLeft (optional)
 * @param {number} props.highlightWidth (optional)
 * @param {Function} props.onHandleMouseDown (optional)
 * @param {string} props.responsiveSize (optional)
 * @param {Function} props.openPatagoniaInpageSectionsPanel (optional)
 * @param {Function} props.openSectionsLibraryModal (optional)
 * @param {boolean} props.hasSectionsLibraryAccess (required)
 * @param {boolean} props.isEmptyLayoutSection (optional)
 * @param {Object} props.bus (optional)
 */
class ResponsiveInsertNewSectionHandle extends Component {
  constructor(...args) {
    super(...args);
    this.handleClick = () => {
      const {
        hasSectionsLibraryAccess,
        id,
        isEmptyLayoutSection,
        targetBeforeOrAfter,
        layoutSectionId,
        bus
      } = this.props;
      const {
        tour
      } = this.context;
      if (hasSectionsLibraryAccess) {
        this.props.openSectionsLibraryModal({
          layoutSectionId,
          rowId: id,
          isEmptyLayoutSection,
          targetBeforeOrAfter,
          gridLayoutId: layoutSectionId,
          beforeNodeId: targetBeforeOrAfter === BEFORE ? id : undefined,
          afterNodeId: targetBeforeOrAfter === AFTER ? id : undefined
        });
        bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.CLICKED_ADD_SECTION_BUTTON));
        if (tour.getTour() === SECTIONS_LIBRARY_TOUR) {
          tour.finish();
        }
      } else {
        this.props.openPatagoniaInpageSectionsPanel();
      }
    };
  }
  render() {
    const {
      top,
      left,
      onHandleMouseDown,
      responsiveSize,
      highlightTop,
      highlightLeft,
      highlightWidth,
      hasSectionsLibraryAccess
    } = this.props;
    const Button = hasSectionsLibraryAccess ? RectangularButton : RoundedButton;
    return /*#__PURE__*/_jsx(Button, {
      icon: AddIcon,
      top: top,
      left: left,
      highlightTop: highlightTop,
      highlightLeft: highlightLeft,
      highlightWidth: highlightWidth,
      useHighlightLine: true,
      responsiveSize: responsiveSize,
      testId: "insert-new-section-button",
      label: hasSectionsLibraryAccess ? I18n.text('inpage.actionToolbar.insertSection.label') : undefined,
      onClick: this.handleClick,
      onMouseDown: onHandleMouseDown
    });
  }
}
ResponsiveInsertNewSectionHandle.contextType = TourContext;
ResponsiveInsertNewSectionHandle.defaultProps = {
  responsiveSize: DEFAULT_RESPONSIVE_SIZE,
  top: OFFSCREEN_POSITION.TOP,
  left: OFFSCREEN_POSITION.LEFT
};
export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveInsertNewSectionHandle);